module.exports = __webpack_public_path__ + "media/images/logos/teach-computing-logo-82ebc29d0da337b06d493f7ea0068aff.png";